import { render } from "./EdgeInferView.vue?vue&type=template&id=164a3aee&scoped=true"
import script from "./EdgeInferView.vue?vue&type=script&lang=js"
export * from "./EdgeInferView.vue?vue&type=script&lang=js"

import "./EdgeInferView.vue?vue&type=style&index=0&id=164a3aee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164a3aee"]])

export default __exports__